import styled from 'styled-components'

export const ImportModalContainer = styled.div`  
  width: 632px;  
  max-height: 90vh;
  overflow-y: auto;
`

export const ImportModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;  
  padding: 24px 32px;
  border-bottom: ${(p) => {
    return p.fileIsPresent ? '1px solid rgba(32, 32, 32, 0.1)' : 'none'
  }};
  pointer-events: ${(p) => {
    return p.isImporting ? 'none' : ''
  }};
  opacity: ${(p) => {
    return p.isImporting ? '0.5' : '1'
  }};
`

export const ImportModalHeaderHalfSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(p) => {
    return p.rightSide ? 'flex-end' : 'flex-start'
  }};
`

export const ImportModalTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
`

export const ImportModalHeaderCloseIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  cursor: pointer;
`

export const ImportModalBody = styled.div`
  margin: 0 32px;
  border: 1px dashed rgba(32, 32, 32, 0.2);
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center; 
  background-color: #FFFFFF;
  
  :hover {
    background-color: rgba(10, 161, 244, 0.03);
    border: 1px dashed rgba(10, 161, 244, 0.7);    
    
    section {
      background-color: rgba(10, 161, 244, 1);
     
      
      svg {
        path {
          fill: #FFFFFF;
        }
      }
      
    }
    
  }
`

export const ImportModalDropContainer = styled.input`
  opacity: 0;
  width: 100%;
  height: 248px;  
  cursor: pointer;
  z-index: 5;
`

export const ImportModalDragFileBanner = styled.div`
  position: absolute;
  color: rgb(80, 18, 18);
  top: 112px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`

export const ImportModalAddFileIconWrapper = styled.section`
  height: 48px;
  width: 48px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: rgba(10, 161, 244, 0.1);
  position: absolute;
  top: 64px;  
  
  svg {
    path {
      fill: rgba(10, 161, 244, 1);
      fill-opacity: 1;
    }
  }
`

export const ImportModalAddFileTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  position: absolute;
  top: 136px;  
`

export const ImportModalAddFileSubTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  position: absolute;
  color: rgba(32, 32, 32, 0.7);
  top: 168px;  
`

export const ImportModalFileWrapper = styled.div`
  display: flex;  
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin: 0 32px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`

export const ImportModalFileDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ImportModalFileIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: ${(p) => {
    return p.error ? 'rgba(225, 25, 0, 0.1)' : 'rgba(10, 161, 244, 0.1)'
  }};
  
  svg {
    path {
      fill-opacity: 1;
      fill: ${(p) => {
    return p.error ? 'rgba(225, 25, 0)' : 'rgba(10, 161, 244)'
  }};
    }
  }  
`

export const ImportModalFileActionsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const ImportModalFileValidationBanner = styled.div`
  height: 24px;
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: #E11900;
`

export const ImportModalFileName = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  margin: 0 8px 0 16px;
`

export const ImportModalFileSize = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
`

export const ImportModalFileDeleteIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  cursor: pointer;
  
  :hover{
    background-color: rgba(225, 25, 0, 0.05);
    svg {
      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0);
      }
    }
  }
`

export const ImportModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 32px;
  pointer-events: ${(p) => {
    return p.isImporting ? 'none' : ''
  }};
  opacity: ${(p) => {
    return p.isImporting ? '0.5' : '1'
  }};
  
`

export const ImportModalFooterBtnWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const ImportModalTemplateWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  user-select: none;
`

export const ImportModalTemplateTitle = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: underline;
`

export const ImportModalTemplateIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: rgba(32, 32, 32, 0.05);
  
  svg {
    path {
      fill-opacity: 1;
      fill: rgba(32, 32, 32);
    }
  }
`

export const ImportModalStatusWrapper = styled.div`
  margin: 16px 32px 180px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.error ? '#E11900' : 'rgba(32, 32, 32, 0.7)'
  }};
`

export const ImportModalStatusIcon = styled.div`
  height: 16px;
  width: 16px;
  display: grid;
  place-items: center;
  cursor: pointer;
  
  svg {
    path {
      fill: rgba(10, 161, 244);
      fill-opacity: 1;
    }
  }
`

export const ImportModalErrorBannerWrapper = styled.div`
  padding: 48px;
  margin: 24px 32px 0;
  border: 1px dashed rgba(225, 25, 0, 0.5);
  background-color: rgba(225, 25, 0, 0.03);
`

export const ImportModalErrorBannerTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 8px;
`

export const ImportModalErrorBannerText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: rgba(32, 32, 32, 0.7);
  margin-bottom: 24px;
`

export const ImportModalErrorBannerFooter = styled.div`
  display: flex;
  gap: 24px;
`

export const ImportModalErrorBannerFooterText = styled.div`
  font-weight: 400;
  line-height: 16px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  
  color: ${(p) => {
    return p.showErrors ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const ImportModalImportBanner = styled.div`
  height: 265px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
`

export const ImportModalImportBannerTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
`

export const ImportModalImportBannerText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;  
  color: rgba(32, 32, 32, 0.7);
`

export const ImportModalImportBannerIcon = styled.div`
  height: 48px;
  width: 48px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: #0AA1F4;
  margin-bottom: 24px;
`

export const ImportModalTemplateIconDropWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  
  :hover {
    svg {
      path {
        fill-opacity: 1;
      }
    }
  }
`

export const ImportModalTemplatesDropDownMenuWrapper = styled.div`
  border-radius: 8px;
  padding: 8px 0;
  background: #FFFFFF;
  position: absolute;
  top: -190px;
  z-index: 5;
  box-shadow: 0 2px 8px -2px rgba(32, 32, 32, 0.1);  
  border: 1px solid rgba(32, 32, 32, 0.1)
`

export const ImportModalTemplatesDropDownItemWrapper = styled.div`
  height: 40px;
  display: flex;
  gap: 8px;
  padding: 0 32px 0 16px;
  align-items: center;
  
  :hover {
    background: rgba(32, 32, 32, 0.05);       
  }
`

export const ReassessmentCheckboxContainer = styled.div`
  margin: 32px;
  display: flex;
  align-items: center;
`